<template>
	<div class="grid mb-4">
		<div class="title">Приёмка</div>
		<form @submit.prevent class="form">
			<BaseGroup title="Данные по заявке" style="padding: 10px">
				<BaseInput v-model="formData.node_ais" placeholder="№ Заявки в АИС" only-number />
				<BaseInput v-model="formData.node_tex" placeholder="№ Оборудования" only-number />
			</BaseGroup>
			<BaseGroup title="Основные данные" class="">
				<BaseSelect
					placeholder="Плашкоуты"
					:options="shipsList"
					required
					v-model:option="formData.receptionPointId"
				/>
				<BaseCombo
					placeholder="Добытчик"
					:options="earnersOptions"
					@click="searchEarners(earner.name)"
					@update:search="searchEarners"
					v-model:search="earner.name"
					v-model:value="earner.id"
					:clearable="true"
					required
				/>
				<BaseCombo
					placeholder="Участок"
					:options="fisherRegionsOptions"
					@click="searchFishingRegions(fisherRegion.name)"
					@update:search="searchFishingRegions"
					v-model:search="fisherRegion.name"
					v-model:value="formData.regionId"
					:clearable="true"
					required
				/>
				<BaseSelect
					:disabled="!!!formData.regionId"
					placeholder="Рыба"
					:options="fishesOptions"
					required
					v-model:option="formData.fishId"
				/>
				<BaseSelect
					:disabled="!!!formData.fishId"
					placeholder="Сорт рыбы"
					:options="fishesSortOptions"
					required
					v-model:option="formData.fishSortId"
				/>
				<BaseInput v-model='formData.weightCorrect' placeholder='Количество, в кг.' required :decimalNumber="true"/>

			</BaseGroup>

			<div class="form--controls">
				<BaseButton @click="addReception" :disabled="formIsInvalid">Создать</BaseButton>
			</div>
		</form>
		<BaseGroup title="Последние события" class="" >
			<TheList :hover="false" :map="listOfActions" />
		</BaseGroup>
	</div>
</template>

<script>
import { onMounted, ref, watch, nextTick } from 'vue'
import BaseGroup from '@/components/ui/BaseGroup'
import BaseInput from '@/components/ui/BaseInput'
import BaseButton from '@/components/ui/BaseButton'
import BaseCombo from '@/components/ui/BaseCombo'
import BaseSelect from '@/components/ui/BaseSelect'
import TheList from '@/components/TheList'
import { useApi } from '@/modules/api'
import { useAlert } from '@/modules/composition/useAlert'
import FormattedDateTime from '@/utils/formattedDateTime'

export default {
	name: 'Reception',
	components: {
		BaseGroup,
		BaseInput,
		BaseButton,
		BaseCombo,
		BaseSelect,
		TheList
	},
	setup () {
		const { errorAlert } = useAlert()
		const factoryId = ref(null)
		const listOfActions = ref({})
		const allEarnersList = ref({})
		const earnersOptions = ref({})
		const fisherRegionsOptions = ref({})
		const fisherRegions = ref({})
		const fishesOptions = ref({})
		const fishesSortOptions = ref({})
		const formIsInvalid = ref(true)
		const earner = ref({ id: null, name: '' })
		const fisherRegion = ref({ id: null, name: '', nameShort: '' })
		const shipsList = ref({})

		const formData = ref({
			boardCompany2shipId: null,
			boardCompany2workerId: null,
			regionId: null,
			fishId: null,
			fishSortId: null,
			weightCorrect: null,
			receptionPointId: null,
			node_ais: null,
			node_tex: null
		})

		watch(formData, async () => {
			await nextTick()
			formIsInvalid.value = document.querySelectorAll(':invalid, .invalid').length > 0
			if (formData.value.node_ais === null && formData.value.node_tex === null) {
				errorAlert('Необходимо заполнить одно из полей в блоке "Данные о заявке"')
				formIsInvalid.value = true
			}
		},
		{ deep: true }
		)

		watch(
			() => earner.value.id,
			async (value) => {
				formData.value.regionId = null
				fisherRegionsOptions.value = {}
				formData.value.fishId = null
				fishesOptions.value = {}
				formData.value.fishSortId = null
				fishesSortOptions.value = {}
				fisherRegions.value = {}
				fisherRegion.value = { id: null, name: '', nameShort: '' }
				if (value) {
					formData.value.boardCompany2shipId = allEarnersList.value[value].boardCompany2ship
					formData.value.boardCompany2workerId = allEarnersList.value[value].boardCompany2workers
					await getFisherRegion()
				} else {
					formData.value.boardCompany2shipId = null
					formData.value.boardCompany2workerId = null
					formData.value.regionId = null
				}
			},
			{ deep: true }
		)
		watch(
			() => formData.value.regionId,
			async () => {
				formData.value.fishId = null
				fishesOptions.value = {}
				formData.value.fishSortId = null
				fishesSortOptions.value = {}
				if (formData.value.regionId) await getFishes()
			},
			{ deep: true }
		)
		watch(
			() => formData.value.fishId,
			async () => {
				formData.value.fishSortId = null
				fishesSortOptions.value = {}
				if (formData.value.fishId) await getFishesSort()
			},
			{ deep: true }
		)

		const searchEarners = async (searchString) => {
			earnersOptions.value = {}
			Object.values(allEarnersList.value).forEach((value) => {
				if (searchString) {
					if (value.name.toLowerCase().includes(searchString.toLowerCase())) {
						earnersOptions.value[value.id] = value.name
					}
				} else {
					earnersOptions.value[value.id] = value.name
				}
			})
		}

		const searchFishingRegions = async (searchString) => {
			fisherRegionsOptions.value = {}
			Object.values(fisherRegions.value).forEach((value) => {
				if (searchString) {
					if (value.name.toLowerCase().includes(searchString.toLowerCase())) {
						fisherRegionsOptions.value[value.id] = value.name
					}
				} else {
					fisherRegionsOptions.value[value.id] = value.name
				}
			})
		}

		const getFisherRegion = async () => {
			const { get, data, error } = useApi(`dictionary/companyFisherRegion/${earner.value.id}`)
			await get()
			if (error.value) {
				errorAlert(`Ошибка при получении списка участков! ${error.value?.message}`)
			} else {
				data.value.forEach(el => {
					el.name = el.nameShort ?? el.name
					fisherRegions.value[el.id] = el
				})
			}
		}
		const getFishes = async () => {
			const { get, data, error } = useApi(`dictionary/fish/region/${formData.value.regionId}`)
			await get()
			if (error.value) {
				errorAlert(`Ошибка при получении списка рыб! ${error.value?.message}`)
			} else {
				data.value.forEach(el => {
					fishesOptions.value[el.id] = el.name
				})
			}
		}
		const getFishesSort = async () => {
			const { get, data, error } = useApi('dictionary/fishSort')
			await get()
			if (error.value) {
				errorAlert(`Ошибка при получении списка сорта рыб! ${error.value?.message}`)
			} else {
				data.value.forEach(el => {
					fishesSortOptions.value[el.id] = el.name
				})
			}
		}
		const getEarners = async () => {
			const { get, data, error } = useApi('boardCompany/allWeb')
			await get()
			if (error.value) {
				errorAlert(`Ошибка при получении списка добытчиков! ${error.value?.message}`)
			} else {
				data.value.forEach(el => {
					allEarnersList.value[el.id] = el
				})
			}
		}
		const getAction = async () => {
			const { get, data, error } = useApi(`/factory/${factoryId.value}/actions`)
			await get()

			if (error.value) {
				errorAlert(`Ошибка при получении списка событий! ${error.value?.message}`)
			} else {
				listOfActions.value = {}
				data.value.forEach(line => {
					const { id, fishName, fishSort, receptionPointName, registerDate, rfid, status, weight, weightCorrect, workerFIO } = line
					let currentWeight = 0
					if (weightCorrect !== 0) {
						currentWeight = weightCorrect
					} else {
						currentWeight = weight
					}
					listOfActions.value[id] = {
						left: `${receptionPointName || ''}: ${fishName || ''}, ${fishSort || ''}${currentWeight ? ', ' + currentWeight + 'кг' : ''}`,
						leftSub: `${status || ''} / ${workerFIO || ''}`,
						right: FormattedDateTime(new Date(registerDate)) || '',
						rightSub: rfid || ''
					}
				})
			}
		}

		const getShips = async () => {
			const { get, data, error } = useApi('receptionPoint/allSimple')
			await get()
			if (error.value) {
				errorAlert(`Ошибка при получении списка плашкоутов! ${error.value?.message}`)
			} else {
				data.value.forEach(el => {
					shipsList.value[el.id] = el.name
				})
			}
		}
		const addReception = async () => {
			const { errorAlert } = useAlert()
			if (formData.value.weightCorrect === '0') {
				console.error('Неверный вес')
				errorAlert('Вес не может ровняться нулю!')
				return
			}
			const { post, error } = useApi('/actionBox/receptionWeb')
			const params = { ...formData.value }
			await post(params)

			if (error.value != null) {
				errorAlert(error.value?.message)
				return
			}

			formData.value = {
				boardCompany2shipId: null,
				boardCompany2workerId: null,
				regionId: null,
				fishId: null,
				fishSortId: null,
				weightCorrect: null,
				receptionPointId: null
			}
			earner.value = { name: '', id: null }
			fisherRegion.value = { name: '', id: null }
			await getAction()
		}

		onMounted(async () => {
			const { id } = JSON.parse(localStorage.account)
			const getWorker = useApi(`worker/${id}`)
			await getWorker.get()
			if (!getWorker.error.value) {
				const placeOfWorks = getWorker?.data?.value?.placeOfWorks?.find(work => work.type === 'factory') || getWorker?.data?.value.placeOfWorks[0]
				if (!placeOfWorks) {
					errorAlert('Для данного пользователя не выбран завод')
				} else {
					const { get, data, error } = useApi(`factory/getFactoryIdByPlaceOfWorks/${placeOfWorks.id}`)
					await get()
					if (!error.value) {
						factoryId.value = data.value.factoryId
						if (!factoryId.value) {
							errorAlert('Для данного пользователя не выбран завод')
						} else {
							await getAction()
						}
					}
				}
			}
			await getEarners()
			await getShips()
		})

		return {
			searchEarners,
			searchFishingRegions,
			getFisherRegion,
			getFishes,
			getFishesSort,
			earnersOptions,
			fisherRegionsOptions,
			fisherRegions,
			fishesOptions,
			fishesSortOptions,
			allEarnersList,
			formData,
			earner,
			fisherRegion,
			formIsInvalid,
			addReception,
			getAction,
			getEarners,
			listOfActions,
			getShips,
			shipsList
		}
	}
}
</script>

<style lang="scss" scoped>
.form {
	&--controls {
		margin-top: 20px;

		.button {
			width: 120px;

			&:first-child {
				margin-right: 10px;
			}
		}
	}
}
</style>
